<template>
    <div class="user_detail_page">
        <div class="header">用户详情</div>
        <div style="margin-top:30px;padding-left:50px;width:100%;min-height:300px">
            <div style="width:50%;float:left">
                <p class="user_detail_msg">姓名：{{msg.name}}</p>
                <p class="user_detail_msg">头像：{{msg.pic}}</p>
                <p class="user_detail_msg">职业：{{msg.professional}}</p>
                <p class="user_detail_msg">城市：{{msg.city}}</p>
                <p class="user_detail_msg">状态：{{msg.status}}</p>
            </div>
            <div style="width:50%;float:left">
                <p class="user_detail_msg">性别：</p>
                <p class="user_detail_msg">ID：</p>
                <p class="user_detail_msg">联系邮箱：</p>
                <p class="user_detail_msg">创建时间：</p>
            </div>
        </div>
        <p class="table_title">绑定设备数：</p>
        <a-table :columns="columns" :data-source="data" style="margin-top:20px">
            
        </a-table>
    </div>
</template>

<script>
const columns = [
  {
    title: '设备ID',
    dataIndex: 'age',
    key: 'name',
    align:'center',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '设备类型',
    dataIndex: 'age',
    key: 'age',
    align:'center',
  },
  {
    title: '绑定用户',
    dataIndex: 'address',
    key: 'address',
    align:'center',
  },
  {
    title: '绑定时间',
    key: 'tags',
    dataIndex: 'tags',
    align:'center',
    scopedSlots: { customRender: 'tags' },
  },
]

export default{
    data(){
        return{
            data:'',
            columns,
            msg:{
                name:'',
                pic:'',
                professional:'',
                city:'',
                status:'',
                gender:'',
                id:'',
                email:'',
                createTime:''
            }
        }
    }
}
</script>


<style lang="less" scoped>
.user_detail_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    margin-left: 5px;
  }
  .user_detail_msg{
      height: 50px;
      line-height: 50px;
  }
  .table_title{
      font-weight: 700;
      margin-top: 50px;
      padding-left: 50px;
  }
}
</style>